import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    form: {
      // zodiac: "",
      // location: "",
      // prayer: "",
      // name: "",
      // pictureUrl: "",
      kathong_id: null,
      srcimg: "",
      wish: "",
    },
  },
  mutations: {
    SET_FORM(state, data) {
      console.log("data", data);
      state.form = {
        ...state.form,
        ...data,
      };
      console.log("state.form");
      console.log(state.form);
      localStorage.setItem("form", JSON.stringify(state.form));
    },
    CLEAR_FORM(state) {
      state.form = {
        kathong_id: null,
        srcimg: "",
        wish: "",
      };
    },
  },
  actions: {
    setFrom({ commit }, data) {
      commit("SET_FORM", data);
    },
    clearForm({ commit }) {
      commit("CLEAR_FORM");
    },
  },
  modules: {},
  getters: {
    getForm(state) {
      return state.form;
    },
  },
});
